<script setup>
import CourseUpcomingSection from '@/js/core/components/parts/courses/CourseUpcomingSection.vue';

defineProps({
  courses: {
    type: Array,
    required: true,
    default: () => [],
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['load-more']);
</script>

<template>
  <div class="courses-view-upcoming">
    <div v-if="courses.length === 0" class="no-results">
      There are no results for selected filters.
    </div>

    <table v-else class="courses-upcoming-table">
      <CourseUpcomingSection
        v-for="group in courses"
        :key="group.date"
        :date="group.label"
        :courses="group.sessions"
      />

      <tbody v-if="hasMore" class="courses-section-item__load-more">
        <tr>
          <td colspan="3">
            <div>
              <a href="#" class="load-more-btn" @click.prevent="$emit('load-more')"> Next page </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped></style>
